import {
  csosUpmApi,
  IAddress,
  IDeaRegistration,
  IError,
  IPageable,
  IRenewable,
  parseDate,
  ResponseCSOSHeaders,
} from '..';
import { pathOr } from 'rambda';
import { left, right, Either } from 'fp-ts/lib/Either';
import { compose as lcompose, map as lmap } from 'lodash/fp';

export const getRenewables = (
  hR: ResponseCSOSHeaders
): Promise<Either<IError, IPageable<IRenewable>>> => {
  return csosUpmApi(hR)
    .get(`/v1/api/upm/dea-registrations/renewal-roles?page=0&limit=100000`)
    .then(getRenewablesSuccess)
    .catch(e => left(e as IError));
};
const toRenewable = (a: IRawRenewable): IRenewable => ({
  ...a,
  expirationDt: new Date(a.expirationDt),
});
const getRenewablesSuccess = lcompose(
  right,
  (b: any) => ({
    total: b.total,
    as: lmap<IRawRenewable, IRenewable>(toRenewable)(b.roles),
  }),
  pathOr<any>({ total: 0, roles: [] }, 'data')
);

interface IRawRenewable {
  roleId: number;
  serialNumber: string;
  renewalInstNo: number;
  role: string;
  expirationDt: number;
  deaNumber: string;
}

interface IRawDeaRegistration {
  role: string;
  deaNum: string;
  deaName: string;
  regStatus: string;
  certStatus: string;
  expDt: number | null;
  busAddress: IAddress | null;
  orgAddress: IAddress | null;
  active: boolean | number | null;
  appStatusCd: string | null;
  appStatusDt: number | null;
  regSrc: string | null;
  provisionDt: number | null;
  deprovisionDt: number | null;
  serialNumber: string | null;
}

export const toDeaRegistration = (
  a: IRawDeaRegistration
): IDeaRegistration => ({
  ...a,
  expDt: parseDate(a.expDt),
  appStatusDt: parseDate(a.appStatusDt),
  provisionDt: parseDate(a.provisionDt),
});

const handleSuccess = lcompose(
  right,
  lmap<IRawDeaRegistration, IDeaRegistration>(toDeaRegistration),
  pathOr<IRawDeaRegistration[]>([], 'data.content')
);

export const getRegistrations = (
  hR: ResponseCSOSHeaders
): Promise<Either<IError, IDeaRegistration[]>> => {
  return csosUpmApi(hR)
    .get(`/v1/api/upm/dea-registrations?page=0&limit=10000`)
    .then(handleSuccess)
    .catch(e => left(e as IError));
};
